<template>
  <div
    class="arrowholder"
    :class="{ down: down, up: up, left: left, right: right }"
    @click="scroll"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="arrowsvg"
      viewBox="0 0 60 60"
    >
      <g class="gsvg">
        <path
          class="arrowstroke annimatearrow"
          :class="{ hide: !down }"
          d="M 10 25 L 30 45 L 50 25"
        />
        <path
          class="arrowstroke annimatearrow"
          :class="{ hide: !up }"
          d="M 10 45 L 30 25 L 50 45"
        />
        <path
          class="arrowstroke annimatearrow"
          :class="{ hide: !left }"
          d="M 45 10 L 25 30 L 45 50"
        />
        <path
          class="arrowstroke annimatearrow"
          :class="{ hide: !right }"
          d="M 25 10 L 45 30 L 25 50"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Arrow",
  props: ["direction", "target"],
  computed: {
    down: function () {
      return this.direction == "down";
    },
    up: function () {
      return this.direction == "up";
    },
    left: function () {
      return this.direction == "left";
    },
    right: function () {
      return this.direction == "right";
    },
  },

  methods: {
    scroll: function () {
      this.$emit("scroll");
    },
  },
};
</script>

<style>
.arrowsvg {
  width: 10vmin;
  height: 10vmin;
  max-width: 50px;
  max-height: 50px;
  margin: 2vmin;
}
.arrowholder {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  mix-blend-mode: difference;
}

.down {
  bottom: 0%;
  left: 0%;
  width: 100%;
}
.up {
  top: 0%;
  left: 0%;
  width: 100%;
}
.left {
  top: 0%;
  left: 0%;
  height: 100%;
}
.right {
  top: 0%;
  right: 0%;
  height: 100%;
}

.arrowstroke {
  fill: none;
  stroke: white;
  stroke-width: 6.5;
  transition: d 0.25s ease-in-out;
  stroke-opacity: 100%;
}

.gsvg {
  transition: all 0.25s 0s ease-in-out;
}
.hide {
  visibility: hidden;
}

.annimatearrow {
  animation: pulse 1.5s infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
  animation-delay: 1s;
}

@keyframes pulse {
  0% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
</style>
